// 디바이스 타입
export const DEVICE_TYPE = {
  DESKTOP: 'desktop',
  TABLET: 'tablet',
  MOBILE: 'mobile',
} as const;

export type TDeviceType = (typeof DEVICE_TYPE)[keyof typeof DEVICE_TYPE];

// 디바이스별 크기 설정
export const DEVICE_DIMENSIONS = {
  desktop: { width: 1024, height: 600 },
  tablet: { width: 768, height: 500 },
  mobile: { width: 375, height: 667 },
} as const;
